import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { arraysHaveSameElements } from '../../DashboardGridIndex.jsx';
import { useSetWidgetAttribute } from '../../hooks/useSetWidgetAttribute.js';

function DatasourceAddSettingRow({ widgetId }) {
    const setAttribute = useSetWidgetAttribute(widgetId);
    const colorScheme = useSelector(state => state.dashboard.colorScheme, arraysHaveSameElements);
    const datasource_mode = useSelector(state => state.dashboard.widgets[widgetId].settings?.datasource_mode);
    const datasources = useSelector(state => state.dashboard.widgets[widgetId].settings?.datasources) || [];

    const addDatasource = () => {
        setAttribute('settings.datasources', [...datasources, {
            colId: "",
            name_item: "",
            value: "",
            target: "",
            background_color: colorScheme[datasources.length % colorScheme.length],
            id: StringHelper.random(8),
        }])
    };

    return (
        datasource_mode != 'grouped' ? (
            <div>
                <button className="btn btn-primary pull-left" onClick={addDatasource}>
                    {I18n.t("add_data_value")}
                </button>
            </div>
        ) : null
    )
}

export default DatasourceAddSettingRow;
